module.exports = __webpack_public_path__ + "img/performanceOfDiamonds.e7fa999.jpg";